import { BulkActionModule } from 'utils/i18n/TModules';

// Translation Keys and Paths
export const ReversalHistoryKey = `ReversalHistory`;
export const TReversalHistory = `${BulkActionModule}:${ReversalHistoryKey}`;
